import { useEffect, useState } from 'react';
import { localStorage } from '@fiverr-private/futile';

export const useModerationAlert = (storageVarName: string) => {
    const [isModerationAlertClosed, setIsModerationAlertClosed] = useState<boolean | undefined>(undefined);

    useEffect(() => {
        const value = localStorage.get(storageVarName);
        setIsModerationAlertClosed(!!value);
        if (value === undefined) {
            localStorage.set(storageVarName, false);
        }
    }, [storageVarName]);

    const closeModerationAlert = () => {
        localStorage.set(storageVarName, true);
        setIsModerationAlertClosed(true);
    };

    return {
        isModerationAlertClosed,
        closeModerationAlert,
    };
};
